import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import Step1 from "../steps/Step1";
import Step2 from "../steps/Step2";
import Step3 from "../steps/Step3";
import Step4 from "../steps/Step4";
import "./addmeeting.css";
import { showConfirm } from "../../../utility/showconfirm";
import Hexapi from "../../../utility/HexAPI/Hexapi";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import Loader from "../../../components/loader/Loader";
import { RxCross1 } from "react-icons/rx";
import TutorialModal from "../../../components/tutorialmodal/Tutorialmodal";
import { BsExclamationCircle } from "react-icons/bs";
import { showCustomSwal } from "../../../components/customswal/Customswal";

const steps = [
  "Meeting Details",
  "Meeting Time",
  "Attendees",
  "Select Host",
];

export default function Addmeeting({isrescheduled = false,defaultattendee,iscategory,meetingInfo,meetingid,hide,getMeetingListData,GetMeetingDetails}) {
  const [activeStep, setActiveStep] = useState(0);
  const [attendessarr,setattendessarr]=useState([])
 const [loading,setloading]=useState(false)
 const [youtubevideo,setyoutubevideo]=useState(false)
  const user = useSelector(
    state => state?.users?.data?.[""]?.[0]
  );
  const userid=user?.empid
   const [formData, setFormData] = useState({
    categoryID:"",
    meetingName: "",
    Description: "",
    Location: "",
    duration: null,
    durationnumber:null,
    Date: "",
    attendees: "",
    googlemeet:0,
    hostempid:userid,
    meetingTime:  dayjs(),
  });
const [errors, setErrors] = useState({
  categoryID: "",
  meetingName: "",
  Description: "",
  Location: "",
  duration: "",
  Date: "",
  attendees: "",
  meetingTime: "",
});
const isStepComplete = (step) => {
  if (step === 0) {
    return (
      formData.categoryID &&
      formData.meetingName &&
      formData.Location &&
      formData.durationnumber &&
      formData.Date
    );
  }

  if (step === 1) {
    return formData.meetingTime;
  }

  if (step === 2) {
    return formData.attendees && formData.attendees.length > 0;
  }

  if (step === 3) {
    return formData.hostempid;
  }

  return false;
};
const handleStepClick = (index) => {
  if (index < activeStep) {
    setActiveStep(index);
    return;
  }


  for (let i = 0; i < index; i++) {
    if (!isStepComplete(i)) {
      showCustomSwal("Please complete previous steps first");
      return;
    }
  }

  setActiveStep(index);
};
  const  convertMinutesToHours = (value) => {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} Hrs`;
      };


const editcancel = async()=>{
 const result= await showConfirm({
  content:"Are you sure you want to discard this meeting?",
  hideCancel:false,
  okText:"Yes",
  cancelText:"No"
 })
 if(result){
  hide()
  setFormData({})
 }
}
const setmeetingdetails = (meetingdetails) => {
  const details = meetingdetails;
  if (!details) return;

  const scheduledDateTime = dayjs(details?.scheduledtime?.date);
  const now = dayjs();

  let finalDate = scheduledDateTime;
  let finalTime = scheduledDateTime;

  
  if (scheduledDateTime.isBefore(now) ) {
    finalDate = now; 
  }

  setFormData({
    meetingName: details.name,
    categoryID: details.categoryid,
    Description: details.description,
    Location: details.location,
    hostempid: details.hostempid,
    googlemeet: details.gmeetenabled,
    attendees: details?.empids,
    durationnumber: details?.duration,
    Date: finalDate,
    meetingTime: finalTime,
    duration: convertMinutesToHours(details?.duration),
  });
};

      useEffect(()=>{
if(meetingInfo){
  console.log(meetingInfo,"meetinginfo")
  setmeetingdetails(meetingInfo)
}
},[meetingInfo])
  const getAddMeetingFormData=async()=>{
try {
   setloading(true)
  const obj={
    query:`HRApp_Droid_Proc_AddMeeting_GetFormData @UserID='{0}'`,
    queryArr:[`${userid}`]
  }
  const resp = await Hexapi(obj)
  console.log(resp,"resp")
 
  if(resp){
    if(resp && resp?.attendees){
      setattendessarr(resp?.attendees)
    }else{
      setattendessarr([])
    }
  }
} catch (error) {
  console.log(error)
}finally{
     setloading(false)
}
  }
   const getEditMeetingGetFormData=async(editid)=>{
    if(!editid) return;
     
try {
 setloading(true)
  const obj={
    query:`HRApp_Droid_Proc_EditMeeting_GetFormData @UserID='{0}' ,@MeetingID='{1}'`,
    queryArr:[`${userid}`,`${editid}`]
  }
  const resp = await Hexapi(obj)
  console.log(resp,"resp")
  if(resp){
    if(resp && resp?.attendees){
      setattendessarr(resp?.attendees)
    }else{
      setattendessarr([])
    }


    if(resp && resp?.meetingdetails && resp?.meetingdetails?.[0]){
    setmeetingdetails(resp?.meetingdetails?.[0])
    }
  }

} catch (error) {
  console.log(error)
}finally{
   setloading(false)
}
  }
   
  useEffect(()=>{
if(userid){

       if(meetingid){
getEditMeetingGetFormData(meetingid)
       }else{
         getAddMeetingFormData()
       }
}
  },[userid])
  
 const addMeeting = async() => {
const meetingDate = formData.Date;
const meetingtime = formData.meetingTime;

let scheduledTime = "";

if (meetingDate && meetingtime) {
  scheduledTime = dayjs(meetingDate)
    .hour(meetingtime.hour())
    .minute(meetingtime.minute())
    .second(0)
    .format("YYYY-MM-DD HH:mm:ss");
}


  try {
    setloading(true)

    const obj1={
  query: `HRApp_Droid_Proc_AddMeeting_SubmitV2 
        @Name='{0}',
        @Description='{1}',
        @Location='{2}',
        @CategoryID='{3}',
        @UserID='{4}',
        @ScheduledTime='{5}',
        @HostEmpID='{6}',
        @Duration='{7}',
        @EmpIDs='{8}',
        @GMeetEnabled='{9}'`,
        
      queryArr: [
        formData.meetingName,
        formData.Description,
        formData.Location,
        formData.categoryID,
        userid,
        scheduledTime,
        formData.hostempid,
        formData.durationnumber,
        formData.attendees,      
        formData.googlemeet ? 1 : 0
      ]
    }
    
     const obj2={
query: `HRApp_Droid_Proc_EditMeeting_SubmitV2 @Name='{0}',
        @Description='{1}',
        @Location='{2}',
        @CategoryID='{3}',
        @UserID='{4}',
        @ScheduledTime='{5}',
        @HostEmpID='{6}',
        @Duration='{7}',
        @EmpIDs='{8}',
        @MeetingID='{9}',
        @GMeetEnabled='{10}'`,
        
      queryArr: [
        formData.meetingName,
        formData.Description,
        formData.Location,
        formData.categoryID,
        userid,
        scheduledTime,
        formData.hostempid,
        formData.durationnumber,
        formData.attendees,
        meetingid,      
        formData.googlemeet ? 1 : 0
      ]
    }
    const obj = meetingid ? obj2 : obj1

    const resp= await Hexapi(obj)

    if(resp && resp[""]){
      const command = resp[""][0].command
      if(command==1){
        showConfirm({
          content:resp[""][0].msg,
          hideCancel:true
        }).then(()=>{
          hide()
          if(getMeetingListData){
            getMeetingListData(true)
          }
          if(meetingid && GetMeetingDetails){
            GetMeetingDetails(true)
          }
          setFormData({})
          setActiveStep(0)
          setattendessarr([])
        })
      }else{
        showConfirm({
          content:resp[""][0].msg,
          hideCancel:true
        })
      }
    }
    console.log(resp,"resp")
  } catch (error) {
 if(error.message =="SQL Error occurred"){
      showCustomSwal("error occurred please try again")
    }
    console.log(error);
  }finally{
    setloading(false)
  }
}

  const handleNext = async () => {
    console.log(formData,"formdata")
if (activeStep === 0) {
  let newErrors = {};
  let missingFields = [];

  if (!formData.categoryID) {
    newErrors.categoryID = "Category is required";
    missingFields.push("Category");
  }

  if (!formData.meetingName) {
    newErrors.meetingName = "Meeting Name is required";
    missingFields.push("Meeting Name");
  }

  if (!formData.Location) {
    newErrors.Location = "Location is required";
    missingFields.push("Location");
  }

  if (formData.duration == null || formData.duration == "00:00 Hrs" || formData.durationnumber == 0) {
    newErrors.duration = "Duration is required";
    missingFields.push("Duration");
  }

  if (!formData.Date) {
    newErrors.Date = "Date is required";
    missingFields.push("Date");
  }

  if (missingFields.length > 0) {
    setErrors(newErrors);
    showCustomSwal(
      `Please fill: ${missingFields.join(", ")}`,
      3000
    );
    return;
  }
}

      if (activeStep == 2) {
    if (!formData.attendees || formData.attendees.length === 0) {
      showCustomSwal("Please select at least one attendee", "error");
        setErrors(prev => ({ ...prev, attendees: "At least one attendee is required" }));
      return;
    }
  }
  if (activeStep == 3) {
  if (!formData.hostempid) {
    await showConfirm({
      content: `Please select a host before ${meetingid ? "updating": "saving"} the meeting.`,
      hideCancel: true,
      okText: "OK"
    });
    return;
  }
}
  if (activeStep === steps.length - 1) {
  const confirmSave = await  showConfirm({
      content:`Are you sure you want to ${meetingid ? "update": "save"} this meeting?`,
      hideCancel:false,
      okText:"Yes",
      cancelText:"No"
    })
    
    if (confirmSave) {
   if(meetingid){
    localStorage.setItem("activityid", meetingid);
    localStorage.setItem("lastactiontype", 2);
   }
    localStorage.setItem("refresh", "true"); 
      addMeeting()
    }
  } else {
    setActiveStep((prev) => prev + 1);
  }
};

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return <Step1 Errors={errors} iscategory={iscategory} meetingid={meetingid} userid={userid} formData={formData} setFormData={setFormData} />;
      case 1:
        return <Step2 meetingid={meetingid} userid={userid} formData={formData} setFormData={setFormData} />;
      case 2:
        return <Step3 curmeetingid={meetingid} defaultattendee={defaultattendee} userid={userid}  formData={formData} setFormData={setFormData}  attendessarr={attendessarr}/>;
      case 3:
        return <Step4 userid={userid} formData={formData} setFormData={setFormData} attendessarr={attendessarr}/>;
      default:
        return null;
    }
  };

  return (
    <div className="container" >
<div className="row">
<div className="col-12" style={{padding:"0px"}}>
<div >
<div>
 <div className="stepper-wrapper1">
 <div style={{display:"flex", justifyContent:"space-between" , alignItems:"center"}}>
  <div style={{display:"flex", gap:"10px", alignItems:"center"}}>
  <p> {meetingid ? "Edit Meeting" : "Create Meeting"}</p>
<span><BsExclamationCircle style={{ fontSize: "16px", cursor: "pointer" , color:"gray", marginBottom:"3px"}} onClick={() => setyoutubevideo(true)} /></span>
  </div>

 <p onClick={()=>editcancel()}><RxCross1 style={{cursor:"pointer" , color:"gray" , fontWeight:"600"}}  /></p>

 </div>
  </div>
  
  <div className="stepper-wrapper" style={{width:"auto"}}>

<Stepper activeStep={activeStep} alternativeLabel className="custom-stepper">
  {steps.map((label, index) => (
   <Step key={index} >
      <StepLabel
       onClick={() => handleStepClick(index)} 
        icon={index + 1}
        StepIconProps={{
          classes: {
            root: "step-icon",
            active: "step-icon-active",
            completed: "step-icon-completed"
          }
        }}
      >
        <span className="step-text colorset" style={{color:activeStep == index && "#1250ac"}}>{label}</span>
      </StepLabel>
    </Step>
  ))}
</Stepper>

</div>

<div style={{padding:"10px" , height:"60vh", overflow:"hidden"}}>
        {renderStep()}
</div>
<div className="main-bottom">
   <div className="button-container">
            
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          variant="outlined"
          style={{padding:"2px 30px"}}
        >
          Back
        </Button>

        <Button
          variant="contained"
          onClick={handleNext}
          style={{padding:"2px 30px"}}
        >
          {activeStep === steps.length - 1 ?  meetingid ? "Update": "Save" : "Next"}
        </Button>
      </div>
  </div>   
    </div>
</div>
</div>
</div>
{
  loading && <Modal style={{backdropFilter:"blur(4px)"}} centered show={loading} onHide={()=>setloading(false)}>
  <Modal.Body>
    <Loader/>
  </Modal.Body>
</Modal>
}
{(youtubevideo) &&
                <TutorialModal show={youtubevideo}
                    hide={() => setyoutubevideo(false)}
                    userid={userid}
                    istutorial={"addmeeting"}
                />
            }
    </div>
  );
}